export enum unitTypes {
  WEIGHT = 'Weight',
  VOLUME = 'Volume',
  VOLUME_LIQUID = 'Volume_Liquid',
  VOLUME_GAS = 'Volume_Gas',
  ELECTRICITY = 'Electric',
  CURRENCY = 'Currency',
  NA = 'NA'
}

export enum emissionUnits {
  T_CO2e = 'tCO2e'
}

export type unitType =
  | unitTypes.WEIGHT
  | unitTypes.VOLUME
  | unitTypes.VOLUME_LIQUID
  | unitTypes.VOLUME_GAS
  | unitTypes.ELECTRICITY
  | unitTypes.CURRENCY
  | unitTypes.NA;
